module.exports = __webpack_public_path__ + "images/4c64ebcb65325a516eba57b34edb3362drone.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drone.png
// module id = Tq2O
// module chunks = 0